module.exports = __webpack_public_path__ + "img/09c-osm-outros-dept-nova.ec8af7c9.png";